module.exports = __webpack_public_path__ + "assets/action-item-44e2b9a8.png";